import type { ComponentProps } from 'react';
import type { LotteryName } from '../../../lottery-purchases/types';
import { SecondaryHeaderContainer } from '../../../SecondaryHeaderContainer/SecondaryHeaderContainer';

type ResultsPageHeaderProps = Omit<ComponentProps<typeof SecondaryHeaderContainer>, 'namespace' | 'title'> & {
  lotteryName: LotteryName;
  title?: string;
};

function ResultsPageHeader({ lotteryName, title = 'results_page', ...props }: ResultsPageHeaderProps) {
  return <SecondaryHeaderContainer {...props} namespace={`lotteries.${lotteryName}`} title={title}></SecondaryHeaderContainer>;
}

export { ResultsPageHeader };
